//# sourceMappingURL=utils.mjs.map
/// <reference types="./utils.d.mts" />
import * as $connector from "../../data_types/data/connector.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $event from "../../redraw/redraw/event.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $e from "../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $platform from "../../tiamat/gleam/javascript/platform.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import * as $brands from "../ds/brands.mjs";
import * as $icons from "../ds/icons.mjs";
import * as $logo from "../ds/logo.mjs";
import * as $outline from "../ds/outline.mjs";
import { Ok } from "../gleam.mjs";

export function stop_propagation() {
  return $e.on_click(
    (event) => {
      return $function.tap(
        undefined,
        (_) => {
          let _pipe = event;
          let _pipe$1 = $mouse.as_event(_pipe);
          return $event.stop_propagation(_pipe$1);
        },
      );
    },
  );
}

export function now() {
  let _pipe = $timestamp.system_time();
  return $timestamp_.to_unix_milliseconds(_pipe);
}

export function is_mac() {
  let $ = $platform.platform();
  if ($ instanceof Ok) {
    let $1 = $[0][1];
    if ($1 instanceof $platform.MacOS) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function mime_icon(mime_type) {
  if (mime_type instanceof $mime_types.Document) {
    return $brands.drive_icons.docs();
  } else if (mime_type instanceof $mime_types.Docx) {
    return $brands.office.word();
  } else if (mime_type instanceof $mime_types.Sheet) {
    return $brands.drive_icons.sheets();
  } else if (mime_type instanceof $mime_types.Xlsx) {
    return $brands.office.excel();
  } else if (mime_type instanceof $mime_types.Pptx) {
    return $brands.office.powerpoint();
  } else if (mime_type instanceof $mime_types.Pdf) {
    return $brands.pdf();
  } else if (mime_type instanceof $mime_types.Csv) {
    return $outline.file_list();
  } else if (mime_type instanceof $mime_types.Qna) {
    return $logo.round();
  } else if (mime_type instanceof $mime_types.Markdown) {
    return $brands.markdown();
  } else if (mime_type instanceof $mime_types.Proposal) {
    return $logo.round();
  } else {
    return $h.none();
  }
}

export function select_icon(mime_type, kind) {
  if (kind instanceof $connector.GoogleDrive) {
    return $brands.drive();
  } else if (kind instanceof $connector.Confluence) {
    return $brands.confluence();
  } else if (kind instanceof $connector.Website) {
    return $icons.globe();
  } else if (kind instanceof $connector.Notion) {
    return $brands.notion();
  } else if (kind instanceof $connector.Steerlab) {
    return mime_icon(mime_type);
  } else if (kind instanceof $connector.SteerlabQna) {
    return mime_icon(mime_type);
  } else if (kind instanceof $connector.SteerlabProposal) {
    return mime_icon(mime_type);
  } else {
    return $h.none();
  }
}

export function optional_attribute(attr, mapper) {
  if (attr instanceof Some) {
    let b = attr[0];
    return mapper(b);
  } else {
    return $a.none();
  }
}

export function optional_prop(builder, prop, mapper) {
  if (prop instanceof Some) {
    let prop$1 = prop[0];
    return mapper(builder, prop$1);
  } else {
    return builder;
  }
}
